<!-- 普通基金头部行情 -->
<template>
  <div class="header-wrapper">
    <!-- 日涨跌幅 -->
    <div class="rate" @click="$goFundApp">
      <div class="rate-value" :style="{ color: getRateColor(basicInfo.riseDay)}">
        <div class="rate-num">{{basicInfo.riseDay}}</div>
        <div v-if="!$isEmpty(basicInfo.riseDay)" class="rate-unit">%</div>
      </div>
      <div class="desc">{{`日涨幅${netValueDate}`}}</div>
    </div>
    <!-- 净值 -->
    <div class="net-value" @click="$goFundApp">
      <div class="net-value-num" >{{ basicInfo.netValue || '--'}}</div>
      <div class="desc">净值</div>
    </div>
    <!-- 收益率 -->
    <div class="profit-rate" @click="$goFundApp">
      <div class="net-value-num" :style="{ color: getRateColor(rateOfFund.value)}"
        >{{rateOfFund.value}}</div>
      <div class="desc-tip">
        <div class="desc">{{rateOfFund.desc}}</div>
        <img
          v-if="rateOfFund.img"
          :src="rateOfFund.img"
          @click="rateOfFund.clickImg"
          class="desc-tip-img"/>
      </div>
    </div>
  </div>
</template>

<script>
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import tool from '../../utils/tool';

export default {

  name: 'normal-market-header',

  props: {
    basicInfo: {
      type: Object,
    },
  },

  computed: {
    netValueDate() { // 最新净值日期
      return isEmpty(this.basicInfo?.netValueDate)
        ? '--' : this.basicInfo?.netValueDate.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2-$3');
    },
    rateOfFund() { // 一年以上展示近一年；不满一年展示成立以来
      return isEmpty(this.basicInfo?.rateYear) ? { // 成立以来
        desc: '成立来',
        value: this.basicInfo.rateSetUp || '--',
        img: 'https://j5.dfcfw.com/sc/image/202110/20211009012345.png',
        clickImg: (e) => {
          e.stopPropagation();
          this.$feedback.showToast({
            title: '该基金成立不满1年',
            duration: 1000,
          });
        },
      } : { // 近一年
        desc: '近1年',
        value: this.basicInfo.rateYear || '--',
        clickImg: () => {},
      };
    },
  },

  methods: {
    // eslint-disable-next-line import/no-named-as-default-member
    getRateColor: tool.getRateColor,
  },
};
</script>

<style lang="less" scoped>
.header-wrapper {
  padding: 10px 0 13px 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.rate {
  width: 45%;
  height: 100%;
}
.rate-value {
  display: flex;
  align-items: baseline;
  font-family: DINAlternate-Bold;
}
.rate-num {
  font-size: 72px;
}
.rate-unit {
  font-size: 36px;
}
.desc {
  color: #999999;
  line-height: 26px;
  font-size: 26px;
  margin-bottom: 10px;
}
.net-value {
  width: 27.5%;
}
.net-value-num {
  font-family: DINAlternate-Bold;
  font-size: 36px;
  color: #000;
  margin-bottom: 13px;
}
.profit-rate {
  width: 27.5%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}
.desc-tip {
  display: flex;
  flex-direction: row;
  justify-content: right;
  text-align: right;
}
.desc-tip-img {
  width: 28px;
  height: 28px;
  margin-left: 8px;
}
</style>
